import { EventEmitter, Injectable } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServerTypes } from 'src/app/models/servers';
import { ApiService } from 'src/app/services/api.service';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { requests } from 'src/app/models/requests';
import { IdType } from 'src/app/models/id-type.enum';
import { tap } from 'rxjs/operators';

@Injectable()
export class InfoFormModalService {
  public noteCreated: Subject<any> = new Subject<any>();
  private callback: Function;
  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private http: HttpClient
  ) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public closeModal(reason: string, modal: NgbActiveModal) {
    modal.close(reason);
    NProgress.done();
  }

  // public createNote(note: string, idName: IdType, id: string): Observable<any> {
  //   return this.http
  //     .post(`${this.url}${requests.note}`, { note, idName, id })
  //     .pipe(tap(() => { 
  //       this.callback(); 
  //       this.noteCreated.next(true) 
  //     }));
  // }

  public createNote(note: string, idName: IdType, id: string): Observable<any> {
    // Ensure `this.callback` is a function or provide a default no-op function
    this.callback = this.callback || (() => {});
  
    return this.http.post(`${this.url}${requests.note}`, { note, idName, id }).pipe(
      tap(() => {
        try {
          // Safely invoke callback
          if (typeof this.callback === 'function') {
            this.callback();
          } else {
            console.warn('Callback is not a function:', this.callback);
          }
          // Emit noteCreated event
          this.noteCreated.next(true);
        } catch (error) {
          console.error('Error invoking callback:', error);
        }
      })
    );
  }
 
  public openModal(instance: string, type: IdType, component, callback: Function = undefined): void {
    const modalRef = this.modalService.open(component, { centered: true, size: "lg" });
    modalRef.componentInstance.instance = instance;
    modalRef.componentInstance.idType = type;
    if(callback != undefined) this.callback = callback;
  }
}
